/*塞en回url字串*/

const urlReplace = (url, pattern, replace) => {
  //let url = window.location.pathname;
  let urlChange = url.replace(
    new RegExp(pattern),
    replace
  ); /*比對tc並用en取代*/
  console.log("url bb", urlChange);
  window.location.pathname = urlChange;
};
export default urlReplace;
